import React from "react";

function Contact() {
  return (
    <div>
      <div className="contact-parent" id="contact">
        <div className="container">
          <h2 className="contact-title">Contacts</h2>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-6">
              <h5 className="contact-sub-title">Free Delivery</h5>
              <p>Aarubari, Tinchuli, Jorpati, Besigaon and Boudha.</p>

              <a href="tel:+977 980-8011299" className="text-secondary">
                <img
                  width="70px"
                  src="https://store-images.s-microsoft.com/image/apps.1025.9007199266244726.168ffd61-a717-4ce9-9153-20280762c94f.99519d70-72b0-44db-a14f-139bd6b8eecf"
                />
                <img
                  width="45px"
                  src="https://image.similarpng.com/very-thumbnail/2020/07/Whatsapp-icon-vector-PNG.png"
                />
                <p>Phone: +977 980-8011299</p>
              </a>
              <a
                href="mailto:vegtiffin195@gmail.com"
                className="text-secondary"
              >
                <p>Email: vegtiffin195@gmail.com</p>
              </a>
            </div>
            <div className="col-12 col-md-6 col-lg-6">
              <h5 className="contact-sub-title">Schedules</h5>
              <p>All-Day 10:00am-7:30pm</p>{" "}
              <h5 className="contact-sub-title">Social Media</h5>
              <a
                href="https://www.facebook.com/Veg-Tiffin-104566288034882/?epa=SEARCH_BOX"
                target="_blank"
              >
                <img
                  width="70px"
                  src="https://i.pinimg.com/originals/58/f4/72/58f4723d8f23906bdcb058604075ad2a.png"
                />
              </a>
              <a
                href="https://www.instagram.com/veg_tiffin/?hl=en"
                target="_blank"
              >
                <img
                  width="70px"
                  src="https://www.vhv.rs/dpng/d/78-781797_facebook-icons-png-transparent-png-download.png"
                />
              </a>{" "}
              <a
                href="https://www.tiktok.com/@vegtiffin?_d=secCgsIARCbDRgBIAMoARI%2BCjwAva0Kl7MdosToIRHiZkA8eKNoayUvYP7s%2BeGPH1NGrPfJcA%2BL709TeN69xo4lFdD6geizYXbDjCO1ZkUaAA%3D%3D&language=en&preview_pb=0&sec_user_id=MS4wLjABAAAAvETWnDBEUDJRENJFKiK_MQXuLo3V972sCpBJm39xuElitXjTv9GgZXN2MyN9C8qO&share_item_id=6869659764901645570&share_link_id=A7D33717-D551-42AA-8CB2-10B45540AB13&timestamp=1599467386&tt_from=facebook&u_code=de32jm5ch45gga&user_id=6862254693171938306&utm_campaign=client_share&utm_medium=ios&utm_source=facebook&source=h5_m"
                target="_blank"
              >
                <img
                  width="70px"
                  src="https://purepng.com/public/uploads/large/tik-tok-logo-6fh.png"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
